/**============================================================
*   [form] formConfirmWP
*   description : フォームの確認画面処理（WP用）
============================================================*/

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementsByClassName('mw_wp_form');
  const returnButton = document.getElementById('return');

  // 確認画面のスタイル調整
  if (form.length !== 0) {
    if (form[0].classList.contains('mw_wp_form_confirm')) {
      // 確認画面のスタイル調整
      const formGaps = document.querySelectorAll('.l-gap--form');
      formGaps.forEach(element => {
        const pTag = document.createElement('p');
        let text = element.innerText;
        pTag.innerText = text;
        const inputs = element.querySelectorAll('input');
        element.innerText = '';
        inputs.forEach(function (input) {
          if (input.getAttribute('name') === 'contact_detail') {
            pTag.style.padding = '24px';
            pTag.style.minHeight = '244px';
            pTag.style.display = 'flex';
            pTag.style.alignItems = 'flex-start';
          }
          element.appendChild(input);
        });
        pTag.classList.add('c-form-confirm');
        element.prepend(pTag);
      });

      // 戻るボタンのclass追加
      returnButton.classList.add('c-button--white');

      // 確認画面の不要要素削除
      const removeElementById = (elementId) => {
        const element = document.getElementById(elementId);
        if (element && element.parentNode) {
          element.parentNode.removeChild(element);
        }
      };
      removeElementById('privacy-policy-wrapper');
      removeElementById('agree-checkbox');

      // メールマガジンを受け取るの出力調整
      const mailmagazine = document.getElementById('mailmagazine-wrapper');
      const divTag = document.createElement('div');
      divTag.classList.add('l-gap--md-2');

      const label = document.createElement('label');
      label.setAttribute('for', 'content');
      label.innerHTML = 'メールマガジンを受け取る<sup class="icon-require">*</sup>';
      divTag.appendChild(label);

      const gapForm = document.createElement('div');
      gapForm.classList.add('l-gap--form');

      const paragraph = document.createElement('p');
      paragraph.classList.add('c-text-md');

      const mailmagazineHTML = mailmagazine.innerHTML;
      if (mailmagazineHTML.match(/メールマガジンを受け取る/)) {
        paragraph.innerHTML = 'はい';
      } else {
        paragraph.innerHTML = 'いいえ';
      }

      gapForm.appendChild(paragraph);
      divTag.appendChild(gapForm);
      const inputs = mailmagazine.querySelectorAll('input');
      inputs.forEach(function (input) {
        if (input.getAttribute('type') === 'checkbox') {
          input.setAttribute('type', 'hidden');
        }
        divTag.appendChild(input);
      });

      mailmagazine.replaceWith(divTag);
    }
  }

});

